// This hook has been moved to src/screens/AnalyticsHub/hooks/usePeriodWeeks.ts
// Re-export for backwards compatibility
export { usePeriodWeeks } from '../screens/AnalyticsHub/hooks/usePeriodWeeks';
